import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";

const LANGUAGES = [
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "uz", label: "Oʻzbekcha", flag: "🇺🇿" },
  { code: "en", label: "English", flag: "🇬🇧" },
];

const LanguageSelect = () => {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState(localStorage.getItem("lang") || i18n.language || "ru");
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const savedLang = localStorage.getItem("lang");
    const detectedLang = (savedLang || i18n.language || "ru").split("-")[0];
    
    if (detectedLang !== i18n.language) {
      i18n.changeLanguage(detectedLang);
    }
    setLang(detectedLang);
  }, [i18n]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (code) => {
    setLang(code);
    i18n.changeLanguage(code);
    localStorage.setItem("lang", code);
    setOpen(false);
  };

  const currentLang = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <div className="flex justify-center">
      <div className="relative w-full max-w-xs sm:max-w-sm md:max-w-md" ref={ref}>
        {/* Кнопка */}
        <button
          onClick={() => setOpen((prev) => !prev)}
          className="
            w-full px-5 py-3 rounded-2xl border border-gray-300 bg-white text-gray-700 text-base
            shadow-md flex items-center justify-between transition-all
            hover:border-blue-400 focus:ring-2 focus:ring-blue-500
          "
        >
          <span className="flex items-center gap-2">
            <span className="text-xl">{currentLang.flag}</span>
            <span>{currentLang.label}</span>
          </span>
          <span className={`text-gray-400 transform transition-transform ${open ? "rotate-180" : ""}`}>
            ▼
          </span>
        </button>

        {/* Выпадающее меню */}
        {open && (
          <div
            className="
              absolute left-0 right-0 mt-2 bg-white rounded-2xl shadow-lg border border-gray-200
              overflow-hidden animate-fadeIn z-10
            "
          >
            {LANGUAGES.map((l) => (
              <button
                key={l.code}
                onClick={() => handleSelect(l.code)}
                className={`
                  w-full text-left px-5 py-3 flex items-center gap-2 text-gray-700 text-base
                  hover:bg-blue-50 transition-all
                  ${l.code === lang ? "bg-blue-100" : ""}
                `}
              >
                <span className="text-xl">{l.flag}</span>
                <span>{l.label}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSelect;
